(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("lodash"), require("i18next"), require("@panter/vue-i18next"), require("xml2js"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "lodash", "i18next", "@panter/vue-i18next", "xml2js", "axios"], factory);
	else if(typeof exports === 'object')
		exports["lbs.pi.webViewer"] = factory(require("vue"), require("lodash"), require("i18next"), require("@panter/vue-i18next"), require("xml2js"), require("axios"));
	else
		root["lbs.pi.webViewer"] = factory(root["vue"], root["_"], root["i18next"], root["@panter/vue-i18next"], root["xml2js"], root["axios"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_175__, __WEBPACK_EXTERNAL_MODULE_176__, __WEBPACK_EXTERNAL_MODULE_72__, __WEBPACK_EXTERNAL_MODULE_293__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition